export default class GeometryComponentFilter {
  filter(geom) {}
}
export default class GeometryComponentFilter {
  filter(geom) {}
}
